(function () {
  const activeCountdowns = new Set();
  let tickTimerId = null;
  let stopTimerId = null;

  function parseCountdownEnd(root) {
    if (!root || !root.dataset.date) return NaN;

    const timezone = root.dataset.timezone;
    const date = root.dataset.date.split('-').filter(function (el) {
      return el !== '';
    });
    const day = parseInt(date[0], 10);
    const month = parseInt(date[1], 10);
    const year = parseInt(date[2], 10);

    let tarhour = 0;
    let tarmin = 0;

    if (root.dataset.time) {
      const time = root.dataset.time.split(':');
      tarhour = parseInt(time[0], 10);
      tarmin = parseInt(time[1], 10);
    }

    const dateString =
      month +
      '/' +
      day +
      '/' +
      year +
      ' ' +
      (tarhour < 10 ? '0' + tarhour : tarhour) +
      ':' +
      (tarmin < 10 ? '0' + tarmin : tarmin) +
      ' GMT' +
      timezone;

    const endTime = new Date(dateString).getTime();
    return Number.isFinite(endTime) ? endTime : NaN;
  }

  function pad(value) {
    return value < 10 && value >= 0 ? '0' + value : String(value);
  }

  function hideFlashSale(flashSale) {
    flashSale.hidden = true;
    flashSale.setAttribute('aria-hidden', 'true');

    const cardWrap = flashSale.closest('.product-card__flash-promo');
    if (cardWrap) {
      cardWrap.hidden = true;
      cardWrap.setAttribute('aria-hidden', 'true');
    }

    const pdpWrap = flashSale.closest('.product__flash-promo');
    if (pdpWrap) {
      pdpWrap.hidden = true;
      pdpWrap.setAttribute('aria-hidden', 'true');
    }
  }

  function showFlashSale(flashSale) {
    flashSale.hidden = false;
    flashSale.removeAttribute('aria-hidden');

    const cardWrap = flashSale.closest('.product-card__flash-promo');
    if (cardWrap) {
      cardWrap.hidden = false;
      cardWrap.removeAttribute('aria-hidden');
    }

    const pdpWrap = flashSale.closest('.product__flash-promo');
    if (pdpWrap) {
      pdpWrap.hidden = false;
      pdpWrap.removeAttribute('aria-hidden');
    }
  }

  function isFlashSaleTracked(flashSale) {
    for (const entry of activeCountdowns) {
      if (entry.flashSale === flashSale) return true;
    }
    return false;
  }

  function pruneDisconnectedCountdowns() {
    activeCountdowns.forEach(function (entry) {
      if (!entry.flashSale.isConnected || !entry.countdownRoot.isConnected) {
        activeCountdowns.delete(entry);
        delete entry.flashSale.dataset.flashPromoInitialized;
      }
    });
  }

  function removeCountdown(flashSale) {
    activeCountdowns.forEach(function (entry) {
      if (entry.flashSale === flashSale) {
        activeCountdowns.delete(entry);
      }
    });
    delete flashSale.dataset.flashPromoInitialized;
  }

  function updateCountdown(countdownRoot) {
    const endTime = parseCountdownEnd(countdownRoot);
    if (!Number.isFinite(endTime)) {
      return false;
    }

    const distance = endTime - Date.now();
    if (distance < 0) {
      return false;
    }

    const totalSeconds = Math.floor(distance / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hoursEl = countdownRoot.querySelector('[data-flash-promo-unit="hours"]');
    const minutesEl = countdownRoot.querySelector('[data-flash-promo-unit="minutes"]');
    const secondsEl = countdownRoot.querySelector('[data-flash-promo-unit="seconds"]');

    if (hoursEl) hoursEl.textContent = pad(totalHours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);

    return true;
  }

  function cancelStopTimer() {
    if (stopTimerId) {
      window.clearTimeout(stopTimerId);
      stopTimerId = null;
    }
  }

  function scheduleStopTimer() {
    cancelStopTimer();
    stopTimerId = window.setTimeout(function () {
      pruneDisconnectedCountdowns();
      if (activeCountdowns.size === 0) {
        stopTickLoop();
      }
    }, 250);
  }

  function tickAllCountdowns() {
    pruneDisconnectedCountdowns();

    if (activeCountdowns.size === 0) {
      scheduleStopTimer();
      return;
    }

    cancelStopTimer();

    activeCountdowns.forEach(function (entry) {
      try {
        if (!updateCountdown(entry.countdownRoot)) {
          hideFlashSale(entry.flashSale);
          removeCountdown(entry.flashSale);
        }
      } catch (error) {
        console.error('Flash promo countdown tick error', error);
        removeCountdown(entry.flashSale);
      }
    });

    if (activeCountdowns.size === 0) {
      scheduleStopTimer();
    } else {
      ensureTickLoop();
    }
  }

  function stopTickLoop() {
    if (tickTimerId) {
      window.clearTimeout(tickTimerId);
      tickTimerId = null;
    }
  }

  function scheduleNextTick() {
    stopTickLoop();
    tickTimerId = window.setTimeout(function () {
      tickAllCountdowns();
      if (activeCountdowns.size > 0) {
        scheduleNextTick();
      }
    }, 1000);
  }

  function ensureTickLoop() {
    if (!tickTimerId && activeCountdowns.size > 0) {
      scheduleNextTick();
    }
  }

  function initFlashSale(flashSale, options) {
    let force = options && options.force;

    if (!flashSale) return;

    if (
      !force &&
      flashSale.dataset.flashPromoInitialized === 'true' &&
      isFlashSaleTracked(flashSale)
    ) {
      return;
    }

    if (
      flashSale.dataset.flashPromoInitialized === 'true' &&
      !isFlashSaleTracked(flashSale)
    ) {
      force = true;
    }

    if (!force && flashSale.dataset.flashPromoInitialized === 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const countdownRoot = flashSale.querySelector('[data-product-flash-promo-countdown]');
    if (!countdownRoot) return;

    removeCountdown(flashSale);

    if (!updateCountdown(countdownRoot)) {
      hideFlashSale(flashSale);
      return;
    }

    showFlashSale(flashSale);
    flashSale.dataset.flashPromoInitialized = 'true';
    activeCountdowns.add({ countdownRoot: countdownRoot, flashSale: flashSale });
    cancelStopTimer();
    ensureTickLoop();
  }

  function initFlashPromoInScope(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('[data-product-flash-promo]').forEach(function (flashSale) {
      initFlashSale(flashSale, { force: !isFlashSaleTracked(flashSale) });
    });

    if (scope && scope.matches && scope.matches('[data-product-flash-promo]')) {
      initFlashSale(scope, { force: !isFlashSaleTracked(scope) });
    }
  }

  function refreshFlashPromoInScope(scope) {
    queueMicrotask(function () {
      initFlashPromoInScope(scope);
      ensureTickLoop();
    });
  }

  function nodeNeedsFlashPromoRefresh(node) {
    if (node.nodeType !== 1) return false;

    if (node.matches && node.matches('[data-product-flash-promo]')) {
      return true;
    }

    if (node.querySelector) {
      return !!node.querySelector('[data-product-flash-promo]');
    }

    return false;
  }

  function setupMutationObserver() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    const observer = new MutationObserver(function (mutations) {
      let shouldRefresh = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (nodeNeedsFlashPromoRefresh(node)) {
            shouldRefresh = true;
          }
        });
      });

      if (shouldRefresh) {
        refreshFlashPromoInScope(document);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    refreshFlashPromoInScope(document);
  }

  window.ProductFlashPromo = {
    init: refreshFlashPromoInScope,
    refresh: initAll
  };

  function bootstrap() {
    initAll();
    setupMutationObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      refreshFlashPromoInScope(event.target);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      initAll();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      initAll();
    }
  });
})();
